<template>
  <div>
    <div>
      <v-flex
        ml-0
        pl-0
        xs12
      >
        <v-switch
          v-model="form.use_fee_structure"
          :label="$t('projects.useFeeStructure')"
          color="primary"
        />
      </v-flex>
      <fee-structure
        v-if="form.use_fee_structure"
        ref="feeStructure"
        :fee-structure="form.fee_structure"
        @onUpdate="onFeeStructureUpdate"
      />
    </div>
    <div>
      <v-layout wrap>
        <v-flex
          v-show="!form.use_fee_structure"
          xs12
          md4
        >
          <v-text-field
            id="management_fee"
            v-model.trim.number="form.management_fee"
            :error-messages="ManagementFeeErrors"
            name="management_fee"
            :label="$t('globals.managementFee')+'*'"
            type="number"
            suffix="%"
            required
            @input="$v.form.management_fee.$touch()"
            @blur="$v.form.management_fee.$touch()"
          >
            <template v-slot:append>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                {{ $t('projects.managementFeeTooltip') }}
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex
          v-show="!form.use_fee_structure"
          xs12
          md4
        >
          <v-text-field
            id="referral_fee"
            v-model.trim.number="form.referral_fee"
            :error-messages="ReferralFeeErrors"
            name="referral_fee"
            :label="$t('globals.referralFee')+'*'"
            type="number"
            suffix="%"
            required
            @input="$v.form.referral_fee.$touch()"
            @blur="$v.form.referral_fee.$touch()"
          >
            <template v-slot:append>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                {{ $t('projects.referralFeeTooltip') }}
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex
          v-show="!form.use_fee_structure"
          xs12
          md4
        >
          <v-text-field
            id="trader_fee"
            v-model.trim.number="form.trader_fee"
            :error-messages="TraderFeeErrors"
            name="trader_fee"
            :label="$t('globals.traderFee')+'*'"
            type="number"
            suffix="%"
            required
            @input="$v.form.trader_fee.$touch()"
            @blur="$v.form.trader_fee.$touch()"
          >
            <template v-slot:append>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                {{ $t('projects.traderFeeTooltip') }}
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex
          v-show="traderFeeExists"
          xs12
        >
          <v-text-field
            id="email"
            v-model.trim="form.sub_trader_email"
            :error-messages="EmailErrors"
            autocomplete="email"
            name="email"
            :label="$t('globals.subTraderEmail') +'*'"
            required
            @input="$v.form.sub_trader_email.$touch()"
            @blur="$v.form.sub_trader_email.$touch()"
          >
            <template v-slot:append>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                {{ $t('projects.subTraderTooltip') }}
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex
          xs12
          md12
        >
          <v-select
            v-model.trim="form.billing_cycle"
            :items="BillingCycleItems"
            :item-text="'name'"
            :item-value="'id'"
            :error-messages="BillingCycleErrors"
            name="billing-cycle"
            :label="$t('projects.billingCycle')+ '*'"
            :value="form.billing_cycle"
            required
            @blur="$v.form.billing_cycle.$touch()"
          />
        </v-flex>
        <v-flex
          v-show="opts.tradingType == 'futures'"
          xs12
          md6
        >
          <v-select
            v-model.trim="form.leverage"
            :items="LeverageItems"
            name="leverage"
            :label="$t('globals.leverage')"
            @change="$v.form.leverage.$touch()"
            @blur="$v.form.leverage.$touch()"
          />
        </v-flex>
        <v-flex
          v-show="opts.tradingType == 'futures'"
          xs12
          md6
        >
          <v-text-field
            id="drawdown"
            v-model.trim.number="form.drawdown"
            :error-messages="MaxAllowedDrawdownErrors"
            name="drawdown"
            :label="$t('globals.allowedDrawdown')"
            maxlength="5"
            type="number"
            suffix="%"
            required
            @input="$v.form.drawdown.$touch()"
            @blur="$v.form.drawdown.$touch()"
          >
            <template v-slot:append>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                {{ $t('projects.drawDownTooltip') }} {{ $t('projects.drawdownHint') }}
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex
          xs12
          md6
        >
          <v-text-field
            id="mindeposit"
            v-model.trim.number="form.mindeposit"
            :error-messages="MinDepositErrors"
            name="mindeposit"
            :label="$t('globals.minDeposit')+'*'"
            type="number"
            :suffix="opts.baseCurrency"
            required
            @input="$v.form.mindeposit.$touch()"
            @blur="$v.form.mindeposit.$touch()"
          >
            <template v-slot:append>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                {{ $t('projects.minDepositTooltip') }}
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>

        <v-flex
          xs12
          md6
        >
          <v-text-field
            id="maxdeposit"
            v-model.trim.number="form.maxdeposit"
            :error-messages="MaxDepositErrors"
            name="maxdeposit"
            :label="$t('globals.maxDeposit')+'*'"
            type="number"
            :suffix="opts.baseCurrency"
            required
            @input="$v.form.maxdeposit.$touch()"
            @blur="$v.form.maxdeposit.$touch()"
          >
            <template v-slot:append>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                {{ $t('projects.maxDepositTooltip') }}
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>

        <v-flex
          xs12
        >
          <v-text-field
            id="maxinvestors"
            v-model.trim.number="form.maxinvestors"
            :error-messages="MaxInvestorsErrors"
            name="maxdeposit"
            :label="$t('globals.allowedInvestors')+'*'"
            type="number"
            required
            @input="$v.form.maxinvestors.$touch()"
            @blur="$v.form.maxinvestors.$touch()"
          >
            <template v-slot:append>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                {{ $t('projects.allowedInvestorsTooltip') }}
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex md12>
          <v-checkbox
            v-model="form.hide_own_balance"
            color="primary"
          >
            <template
              v-slot:label
            >
              <small>
                {{ $t('projects.hideOwnBalance') }}
              </small>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  maxLength,
  email,
  between
} from "vuelidate/lib/validators";
import { mapMutations, mapGetters } from "vuex";
import FeeStructure from "@/views/Modules/SpotFutures/Strategies/partial/FeeStructure.vue";

export default {
  name: "FormProfile",
  components: {
    FeeStructure,
  },
  mixins: [validationMixin],
  props: {
    opts: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      BillingCycleItems: [
        { id: "oneday", name: this.$t("projects.oneday")},
        { id: "oneweek", name: this.$t("projects.oneweek")},
        { id: "twoweeks", name: this.$t("projects.twoweeks")},
        { id: "month", name: this.$t("projects.month")},
        { id: "threemonths", name: this.$t("projects.threemonths")},
        { id: "sixmonths", name: this.$t("projects.sixmonths")},
        { id: "oneyear", name: this.$t("projects.oneyear")},
      ],
      LeverageItems: [
        "Cross",
        "1:1",
        "1:2",
        "1:3",
        "1:4",
        "1:5",
        "1:10",
        "1:15",
        "1:20",
        "1:25",
        "1:30",
        "1:40",
        "1:50",
        "1:60",
        "1:70",
        "1:80",
        "1:90",
        "1:100",
        "1:150",
        "1:200",
        "1:300",
        "1:400"
      ],
      form: {
        billing_cycle: null,
        leverage: "1:1",
        management_fee: 0,
        referral_fee: 0,
        trader_fee:0,
        insurance: 0,
        drawdown: 0,
        mindeposit: 0,
        maxdeposit: 0,
        maxinvestors: 0,
        sub_trader_email: null,
        fee_structure: [],
        hide_own_balance: false
      }
    };
  },
  validations() {
    return {
      form: this.rules
    };
  },
  computed: {
    ...mapGetters("project", ["getProject"]),
    traderFeeExists() {
      if (!this.form.use_fee_structure) {
        return this.form.trader_fee > 0
      } 
      const fee = this.form.fee_structure.find((item) => {
        return item.trader_fee > 0
      })
      return fee == undefined ? false : true
    },
    rules() {
      var form = {
        billing_cycle: {
          required
        },
        leverage: {
          required
        },
        drawdown: {
          required,
          between: between(5, 100)
        },
        management_fee: {
          required,
          between: between(0, 100)
        },
        referral_fee: {
          required,
          between: between(0, 100)
        },
        trader_fee: {
          required,
          between: between(0, 100)
        },
        mindeposit: {
          required,
        },
        maxdeposit: {
          required,
        },
        maxinvestors: {
          required,
          between: between(0, 100000)
        },
        drawdown: {
          required,
          between: between(5, 100)
        },
        sub_trader_email: {
            required: requiredIf(() => (this.traderFeeExists)),
            email,
            maxLength: maxLength(255),
        },
      };
      return form;
    },
    BillingCycleErrors() {
      const errors = [];
      if (!this.$v.form.billing_cycle.$dirty) return errors;
      !this.$v.form.billing_cycle.required &&
        errors.push(this.$t("projects.reqField"));
      return errors;
    },
    ManagementFeeErrors(value) {
      const errors = [];
      if (!this.$v.form.management_fee.$dirty) return errors;
      !this.$v.form.management_fee.required &&
        errors.push(this.$t("projects.reqField"));
      !this.$v.form.management_fee.between &&
        errors.push(this.$t("projects.0100Field"));  
      return errors;
    },
    ReferralFeeErrors(value) {
      const errors = [];
      if (!this.$v.form.referral_fee.$dirty) return errors;
      !this.$v.form.referral_fee.required &&
        errors.push(this.$t("projects.reqField"));
      !this.$v.form.referral_fee.between &&
        errors.push(this.$t("projects.0100Field"));  
      return errors;
    },
    TraderFeeErrors(value) {
      const errors = [];
      if (!this.$v.form.trader_fee.$dirty) return errors;
      !this.$v.form.trader_fee.required &&
        errors.push(this.$t("projects.reqField"));
      !this.$v.form.trader_fee.between &&
        errors.push(this.$t("projects.0100Field"));  
      return errors;
    },
    MinDepositErrors(value) {
      const errors = [];
      if (!this.$v.form.mindeposit.$dirty) return errors;
      !this.$v.form.mindeposit.required &&
        errors.push(this.$t("projects.reqField"));
      return errors;
    },
    MaxDepositErrors(value) {
      const errors = [];
      if (!this.$v.form.maxdeposit.$dirty) return errors;
      !this.$v.form.maxdeposit.required &&
        errors.push(this.$t("projects.reqField"));
      return errors;
    },
    MaxInvestorsErrors(value) {
      const errors = [];
      if (!this.$v.form.maxinvestors.$dirty) return errors;
      !this.$v.form.maxinvestors.required &&
        errors.push(this.$t("projects.reqField"));
      !this.$v.form.maxinvestors.between &&
        errors.push(this.$t("projects.0100kField"));  
      return errors;
    },
    MaxAllowedDrawdownErrors(value) {
      const errors = [];
      if (!this.$v.form.drawdown.$dirty) return errors;
      !this.$v.form.drawdown.required &&
        errors.push(this.$t("projects.reqField"));
      !this.$v.form.drawdown.between &&
        errors.push(this.$t("projects.530Field"));
      return errors;
    },
    EmailErrors () {
      const errors = []
      if (!this.$v.form.sub_trader_email.$dirty) return errors
      !this.$v.form.sub_trader_email.required &&
        errors.push(this.$t('register.reqEmail'))
      !this.$v.form.sub_trader_email.email &&
        errors.push(this.$t('register.validEmail')) 
      !this.$v.form.sub_trader_email.maxLength &&
        errors.push(this.$t('register.mustEmail'))
      return errors
    },
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "project/setProject") {
        this.form = state.project.form;
      }
    });
  },
  methods: {
    ...mapMutations("project", ["saveDetails", "setTab"]),
    onFeeStructureUpdate(fees) {
      this.form.fee_structure = fees
    },
    save() {
      this.$v.$touch();
      if (this.form.use_fee_structure) {
        this.$refs.feeStructure.$v.$touch();
        if (this.$refs.feeStructure.$v.$invalid) {
          return
        }
        this.form.fee_structure = this.$refs.feeStructure.fees
      }
      if (this.opts.tradingType == 'spot') {
        this.form.leverage = '1:1'
        this.form.drawdown = 100
      }
      if (!this.$v.$invalid) {
        this.saveDetails(this.form);
      }
    },
  }
};
</script>

<style>
</style>
